import { distinctUntilChanged, type Observable } from 'rxjs'
import type { WorkspaceMember } from '@/features/iam/members/WorkspaceMember'
import { filterNonNil } from '@/utils/rx-util'
import { createTrackingService } from '@/features/tracking/TrackingService'
import { take } from 'rxjs/operators'

export interface TrackingFeatureOptions {
  currentMember$: Observable<WorkspaceMember>
  logout$: Observable<void>
}

export type TrackingFeature = ReturnType<typeof TrackingFeature>

export function TrackingFeature(options: TrackingFeatureOptions) {
  const trackingService = createTrackingService()

  options.currentMember$
    .pipe(filterNonNil(), distinctUntilChanged(), take(1))
    .subscribe((member) => trackingService.identify(member))

  options.logout$.pipe(take(1)).subscribe(() => trackingService.reset())

  return {
    trackingService,
  }
}
